import ManualEntryEssentialNeedsCalculator from "./ManualEntryEssentialNeedsCalculator.vue"

export default ManualEntryEssentialNeedsCalculator